import $ from 'jquery'

Ready(function() {
  const triggerCheckbox = 'input[data-hide-div]'

  const allDaySwitch = (e) => {
    let checkBox = $(e.target)
    let divName = checkBox.data('hide-div')

    const div = $(`.hide-${divName}`)
    const inputs = div.find(':checkbox')

    let showDiv = checkBox.is(':checked')

    let invert = checkBox.data('hide-invert')
    if (invert) {
      showDiv = !showDiv
    }

    if(showDiv) {
      div.addClass('d-none')
      // Check all checkboxes inside the div
      if (checkBox.data('unhide-checked') )
        inputs.prop("checked", true)
    } else {
      div.removeClass('d-none')
    }
  }

  // Makes sure div is shown if user reload the page
  const initHideDiv = () => {
    let trigger_checkbox_values = Object.keys($(triggerCheckbox)).map(tc => $(triggerCheckbox)[tc])
    trigger_checkbox_values.forEach(element => allDaySwitch({ target: element }))
  }

  initHideDiv()
  $('body').on('click', triggerCheckbox, allDaySwitch)
  $(document).on('ajax:complete:custom', allDaySwitch)
})
